import React from 'react';
import Button from '../ui/Button';

interface CustomModalProps {
    title: string;
    title2?: string;
    buttonTxt?: string;
    buttonTxt2?: string;
    showCancel?: boolean;
    toggleModal: () => void;
    onConfirm: () => void;
    loading?: boolean
}

const CustomModal: React.FC<CustomModalProps> = ({ title, loading, title2, buttonTxt = 'Confirm', buttonTxt2 = 'Cancel', showCancel = true, toggleModal, onConfirm }) => {
    const modalRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const previouslyFocusedElement = document.activeElement as HTMLElement;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                toggleModal();
                return;
            }
            if (e.key === 'Tab' && modalRef.current) {
                const focusableElements = modalRef.current.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex="0"]'
                );
                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0] as HTMLElement;
                const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        e.preventDefault();
                    }
                }
            }
        };

        if (modalRef.current) {
            const focusableElements = modalRef.current.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex="0"]'
            );
            if (focusableElements.length > 0) {
                (focusableElements[0] as HTMLElement).focus();
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
                previouslyFocusedElement.focus();
            }
        };
    }, [toggleModal]);

    return (
        <div className='custom-modal'>
            <div className='custom-modal-backdrop' onClick={toggleModal} aria-hidden="true"></div>
            <div 
                ref={modalRef}
                className='custom-modal-body'
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
                aria-describedby={title2 ? "modal-description" : undefined}
            >
                <div id="modal-title" className='logout-txt'>{title}</div>
                {title2 && <div id="modal-description" className='title-txt-2'>{title2}</div>}
                <div className='custom-modal-foot'>
                    {showCancel &&
                        <button className='custom-modal-btn modal-light-btn' onClick={toggleModal}>{buttonTxt2}</button>
                    }
                    <Button type='button' className='custom-modal-btn modal-dark-btn' onClick={onConfirm} loading={loading}>{buttonTxt}</Button>
                </div>
            </div>
        </div>
    )
}


export default CustomModal
